// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3626":"a86c24bea9f411a5","8952":"29471a4143fdfcd6"}[chunkId] + ".js";
};